/**
 * Formats an ISO timestamp the way the live blog renders dates ("May 29, 2026")
 * — used by the post byline and the Press feed's announcement cards.
 *
 * en-US is correct unconditionally: the blog is default-locale-only. Formatting
 * in UTC keeps the output a pure function of the stored timestamp (not the
 * ambient clock or server TZ), satisfying `invariants.md#ssr-safe-rendered-dates`.
 */
export function formatPublishDate(iso: string): string {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(iso))
}
